import { render, staticRenderFns } from "./pioneer6-features.vue?vue&type=template&id=2b460d2c&scoped=true"
import script from "./pioneer6-features.vue?vue&type=script&lang=js"
export * from "./pioneer6-features.vue?vue&type=script&lang=js"
import style0 from "./pioneer6-features.vue?vue&type=style&index=0&id=2b460d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b460d2c",
  null
  
)

export default component.exports